import React from "react";
import locale from "localization";

export const paymentHistoryColumns = [
  {
    key: "redemptionId",
    text: locale.redemptionId,
    style: {
      minWidth: "200px",
    },
  },
  {
    key: "fuelCodeRedemptionDate",
    text: (
      <>
        {locale.fuelCodeCapitalize} / <br /> {locale.redemptionDate}
      </>
    ),
    style: {
      minWidth: "300px",
    },
  },
  {
    key: "businessName",
    text: locale.businessName,
    style: {
      minWidth: "400px",
    },
  },
  {
    key: "driverIdPlateNumber",
    text: (
      <>
        {locale.driverId} / <br /> {locale.plateNumber}
      </>
    ),
    style: {
      minWidth: "250px",
    },
  },
  {
    key: "productVolume",
    text: (
      <>
        {locale.product} / <br /> {locale.volume}
      </>
    ),
    style: {
      minWidth: "220px",
    },
  },
  {
    key: "totalCreditAmountSales",
    text: (
      <>
        {locale.totalCreditAmount} / <br /> {locale.totalSales}
      </>
    ),
    style: {
      minWidth: "300px",
    },
  },
  {
    key: "averageCreditPrice",
    text: `${locale.averageCreditPrice}`,
    style: {
      minWidth: "300px",
    },
  },
  {
    key: "discountPremium",
    text: (
      <>
        {locale.discount} / <br /> {locale.premium}
      </>
    ),
    style: {
      minWidth: "250px",
    },
  },
  {
    key: "orNumber",
    text: locale.orNumber,
    style: {
      minWidth: "250px",
    },
  },
  {
    key: "status",
    text: `${locale.status}`,
    style: {
      minWidth: "230px",
    },
  },
  {
    key: "remarks",
    text: locale.remarks,
    style: {
      minWidth: "230px",
    },
  },
  {
    key: "settlementStatus",
    text: `${locale.settlementStatus}/${locale.settlementId}`,
    style: {
      minWidth: "350px",
    },
  },
  {
    key: "options",
    text: `${locale.action}`,
    style: {
      width: "100px",
    },
  },
];
